/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmAgendovaRoleFunkce extends GContentBase<SeznamAdmAgendovaRoleFunkceObj> {
        private seznamObj: SeznamAdmAgendovaRoleFunkceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmAgendovaRoleFunkceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmAgendovaRoleFunkceNew",
                contentCaption: "jres:33000767", //RC 33000767 : P�i�azen� agendov� role funkc�m
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{agenda} - {agendova_role} - {ixs_fun_txt}"
                },
                gridSettings: {
                    columnOrder: "agenda,agendova_role,agendova_role_txt,ixs_fun_txt,dat_zmena,zmenu_prov_txt",
                    defaultSort: "agendova_role"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmAgendovaRoleFunkceObj extends GAdmSeznamBase {
        private ixs_fun: string;
        private agenda: string;

        create() {
            this.cnt.showFlash({
                content: "jres:33000773", //RC 33000773 : Toto je pouze p�ehled, nastaven� agend a rol� je mo�n� na detailu funk�n�ho m�sta.
                state: "info"
            })
        }

        openDetail(data: any, isNew: boolean) {
            //$.content().navigate(["Gordic.Adm.WebControls.DetailAdmAgendovaRoleFunkce", {
            //    currentFilter: this.filterData,
            //    gridRc: new Gordic.Components.GridRC(this.grid)
            //}], {
            //    ID: "DetailAdmAgendovaRoleFunkce",
            //    newRecord: isNew,
            //    ixs_fun: isNew == true ? null : data.ixs_fun,
            //    agenda: isNew == true ? null : data.agenda,
            //    agendova_role: isNew == true ? null : data.agendova_role
            //})
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                //"actOpenDetail*",
                //"actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000757").addField("gselectbox", Gordic.Prefabs.Select.szrsage(), { //RC 33000757 : Agenda
                name: "agenda",
                model: "model.agenda=value.agenda",
                dropdown: true,
                disabled: this.agenda ? true : false,
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            }).addRow("jres:29802552").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                disabled: this.ixs_fun ? true : false,
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_fun)
                hardFilter["ixs_fun"] = this.ixs_fun;
            if (this.agenda)
                hardFilter["agenda"] = this.agenda;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_fun)
                data["ixs_fun"] = this.ixs_fun
            if (this.agenda)
                data["agenda"] = this.agenda
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmAgendovaRoleFunkce.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.view.process({
                    ac: new Gordic.Data.Grouping([{
                        defaultState: "open",
                        hash: (meta, rows) => {
                            return `<span class='adm-no-bold'>jres:29929729:</span> <b>${meta.data.ixs_fun_txt}</b>`
                        }
                    }]),
                    ac2: new Gordic.Data.Grouping([{
                        defaultState: "open",
                        hash: (meta, rows) => {
                            return `<span class='adm-no-bold'>jres:33000753:</span> <b>${meta.data.agenda} - ${meta.data.agenda_txt}</b>`
                        }
                    }])
                })
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.ixs_fun, data.agenda, data.agendova_role),
                nazev: "{0} - {1} - {2}".format(data.ixs_fun_txt, data.agenda, data.agendova_role),
            }
        }
    }
}